module.exports = __webpack_public_path__ + "img/titlev4@2x.2ce2797e.png";